//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Sketch.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[1,"CornerRadius",0,"Expression",0],[0,"CoutoutType",1,0],[0,"CutoutPart",1,"Part",0],[1,"Diameter",0,"Expression",0],[0,"DirectionType",1,0],[1,"Height",0,"Expression",0],[0,"IsEditMode",1,0],[0,"IsKeepAssociation",1,0],[0,"ModifiedSketch",1,"Sketch",0],[1,"Offset",0,"Expression",0],[0,"Point",1,"Point",0],[1,"Radius",0,"Expression",0],[0,"SketchSection",1,"Section",0],[1,"Width",0,"Expression",0]],[[[],"ButtonCutout",{},0,0],[["request"],"AddRequest",{},1,0],[["adjacentStructure"],"AddAdjacentStructure",{},1,0],[["structure"],"AddNonIntersectedStructure",{},1,0],[[],"RemoveNonIntersectedStructures",{},0,0],[["curve"],"AddSelectedCurve",{},1,0],[[],"RemoveSelectedCurves",{},0,0],[["selectionCompensationNumber"],"SetCompensationPartNumber",{},1,0]],[]];
SPLM.Features.ShipDesign.PenetrationAssociationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PenetrationAssociationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;